import { render } from "./HeroiconsSolidGlobeAlt.vue?vue&type=template&id=11542a04"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidGlobeAlt.vue"]])

export default __exports__